import React, { useEffect, useState } from "react";
import { theme } from "../../../assets/theme";
import useApi from "../../../hooks/useApi";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import ProductList from "../ProductList";

const FeaturedProductList = ({ isTabletOrMobile }) => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [getFeaturedProductsResponse, getFeaturedProductsRequest] = useApi(
    "/website/home/featured-products",
    null,
    API_METHODS.GET
  );

  useEffect(() => {
    getFeaturedProductsRequest();
  }, []);

  useEffect(() => {
    const data =
      getFeaturedProductsResponse.data !== BLANK_VALUE
        ? getFeaturedProductsResponse.data
        : [];
    setFeaturedProducts(data);
  }, [getFeaturedProductsResponse]);

  return (
    <div className="featured-products-container">
      <div className="featured-products-header">
        <h1 className="featured-products-title">Featured Products</h1>
        {/* Add navigation arrows here if needed */}
      </div>

      <ProductList
        products={featuredProducts}
        isTabletOrMobile={isTabletOrMobile}
      />
    </div>
  );
};

export default FeaturedProductList;
